import { createSelector } from 'reselect';
import get from 'lodash.get';
const TOKEN_PROVIDER_CONFIGURATION_TYPE = 'cc_token_provider';
const initSelectors = (reducerPath) => {
    // Common
    const getContextData = (state) => get(state, `${reducerPath}.contextData`);
    const isFetchingResources = createSelector(getContextData, contextData => contextData.isFetchingResources);
    const isFetchingProviderConfigs = createSelector(getContextData, contextData => contextData.isFetchingProviderConfigs);
    const isFetchingBusinessUnits = createSelector(getContextData, contextData => contextData.isFetchingBusinessUnits);
    const isFetchingSftpFolders = createSelector(getContextData, contextData => contextData.isFetchingSftpFolders);
    // Provider Configurations
    const getConfigs = createSelector(getContextData, contextData => {
        return contextData.providerConfigurations || [];
    });
    const getConfigIds = createSelector(getConfigs, (configurations) => {
        return configurations.map((config) => config.id);
    });
    const getNonTokenProviderConfigs = createSelector(getConfigs, (configurations) => (configurations.filter((config) => (config.type !== TOKEN_PROVIDER_CONFIGURATION_TYPE))));
    // Business Units
    const getApps = createSelector(getContextData, contextData => {
        return contextData.businessUnits || [];
    });
    const getParsedApps = createSelector([getApps], (apps) => {
        const reverseDomain = window.zooz_account.reverseDomain();
        return apps.map((app) => {
            const appName = get(app, 'id', '').replace(`${reverseDomain}.`, '');
            return Object.assign({}, app, { name: appName });
        });
    });
    const getAppsWithProviderConfiguration = createSelector([getParsedApps, getConfigs], (apps, providerConfigs) => apps.map(businessUnit => {
        const providerConfiguration = providerConfigs.find(c => c.id === businessUnit.default_processor);
        return providerConfiguration ? Object.assign(Object.assign({}, businessUnit), { providerConfiguration }) : Object.assign({}, businessUnit);
    }));
    // Sftp Folders
    const getSftpFolders = createSelector(getContextData, contextData => {
        return contextData.sftpFolders || [];
    });
    /// /////////
    return {
        isFetchingResources,
        providerConfigurations: {
            isFetching: isFetchingProviderConfigs,
            getConfigs,
            getConfigIds,
            getNonTokenProviderConfigs
        },
        businessUnits: {
            isFetching: isFetchingBusinessUnits,
            getApps,
            getAppsWithProviderConfiguration
        },
        sftp: {
            isFetching: isFetchingSftpFolders,
            getFolders: getSftpFolders
        }
    };
};
export default initSelectors;
